import axios, { getData } from 'lib/axios'

export const getNonActiveRun = async () => {
  return axios.get('admin/time').then(getData)
}

export const getActiveRun = async (year) => {
  return axios.get(`admin/activepayroll?year=${year}`).then(getData)
}

export const runMonthlyPayroll = async (data) => {
  return axios.post('admin/payroll', data)
}
